import type { Game } from '@game/types'
import type { GameSection } from '@game/composables/useGameSection'
import type { useHero, Ref, ComputedRef } from '#imports'

export const LAYOUT_CONTEXT_KEY = Symbol() as InjectionKey<{
    hero: Awaited<ReturnType<typeof useHero>>
    personalizedHeroGame: ComputedRef<Game | null | undefined>
    personalizedGamesSection: Ref<GameSection>
    personalizedGamesSectionLoading: ComputedRef<boolean>
    fetchPersonalizedContent: ComputedRef<boolean>
    personalizedContentVisible: ComputedRef<boolean>
}>

export const useLayoutContext = () => {
    const context = inject(LAYOUT_CONTEXT_KEY)

    if (!context) {
        throw new Error('No layout context provided')
    }

    return context
}
